module.exports = __webpack_public_path__ + "static/media/LogoOnScreen.52bf02e0.png";